import React, { useState, useEffect, useRef } from "react";
import { activateEnterpriseBots } from "../../../../services/api/BotApiServices";
import { FRONTM_DOMAIN } from "../../../../utils/constants";
import { loadAllDomainsListInLFStorage } from "../../../../services/storage/LFStorage";
import { BUTTON_BACKGROUND_COLOR_STYLE } from "../../../../utils/ColorPicker";
import Spinner from "react-spinkit";

const errorBannerStyle = {
	width: "100%",
	backgroundColor: "rgba(213, 145, 142,0.4)",
	transition: "all .5s ease-in-out",
	position: "absolute",
	top: "0",
	left: 0,
	padding: "14px 15px",
	borderRadius: "15px 15px 0 0",
	fontWeight: "600",
	color: "#a12727",
	fontSize: "17px",
	zIndex: -1
};
const successBannerStyle = {
	width: "100%",
	backgroundColor: "rgba(213, 145, 142,0.4)",
	transition: "all .5s ease-in-out",
	position: "absolute",
	top: "0",
	left: 0,
	padding: "14px 15px",
	borderRadius: "15px 15px 0 0",
	fontWeight: "600",
	color: "#a12727",
	fontSize: "17px",
	zIndex: -1
};

const GetCreditModal = ({ addCredit, user, hideSpinner, codeAlreadyApplied }) => {
	const [selectedAmount, setSelectedAmount] = useState(0);
	const [success, setSuccess] = useState(null);
	const [error, setError] = useState(null);
	const [showBanner, setShowBanner] = useState(false);
	const [promoCode, setPromoCode] = useState("");
	const [disabledPromoCode, setDisabledPromoCode] = useState(false);
	const [disabledApplyBtn, setDisabledApplyBtn] = useState(true);
	const [codeApplied, setCodeApplied] = useState(codeAlreadyApplied);
	const [isTooltipVisible, setIsTooltipVisible] = useState(false);
	const [applyLoading, setApplyLoading] = useState(false)

	const [amountList, setAmountList] = useState([
		{ amountValue: 10, currency: "$", classSelected: "" },
		{ amountValue: 50, currency: "$", classSelected: "" },
		{ amountValue: 100, currency: "$", classSelected: "" },
	]);

	useEffect(() => {
		setIsTooltipVisible(false);
	}, []);

	const handleMouseEnter = () => setIsTooltipVisible(true);
	const handleMouseLeave = () => setIsTooltipVisible(false);

	const selectAmount = (amount, index) => {
		const updatedAmounts = amountList.map((item, idx) => ({
			...item,
			classSelected: idx === index ? "selected-amount" : "",
		}));
		setAmountList(updatedAmounts);
		setSelectedAmount(amount.amountValue);
	};

	const modifyAmount = (e) => {
		const val = e.target.value;
		const regCheck = /^[0-9]{0,5}(\.[0-9]{0,2})?$/;

		const updatedAmounts = amountList.map((item) => ({
			...item,
			classSelected: "",
		}));

		if (!val.length || regCheck.test(val)) {
			setSelectedAmount(val === "" ? 0 : parseFloat(val));
			setAmountList(updatedAmounts);
		}
	};

	const changePromoCode = (e) => {
		const value = e.target.value;
		setPromoCode(value);
		setDisabledApplyBtn(value.length <= 2);
		setSuccess(null);
		setError(null);
		setShowBanner(false);
	};

	const applyPromoCode = (e) => {
		e.preventDefault();
		setApplyLoading(true)
		const code = promoCode;

		activateEnterpriseBots(code)
			.then((response) => {
				setShowBanner(true);
				if (!response.content || response.content[0] == null) {
					setError("Incorrect code. Try again");
					setSuccess(null);
					setApplyLoading(false)
				} else {
					const corporateDomains = response.content.filter(
						(domain) => domain.userDomain !== FRONTM_DOMAIN
					);
					loadAllDomainsListInLFStorage(corporateDomains);
					setSuccess("Partner code applied successfully");
					setError(null);
					setDisabledPromoCode(true);
					setDisabledApplyBtn(true);
					setCodeApplied(true);
					setApplyLoading(false)
				}
			})
			.catch((err) => {
				setShowBanner(true);
				setError(err.message || "Sorry something went wrong. Please contact support");
				setSuccess(null);
				setApplyLoading(false)
			});
	};

	const handleSubmitAmount = () => {
		setSuccess(null);
		setError(null);
		setShowBanner(false);
		addCredit(selectedAmount, codeApplied);
	};

	return (
		<div>
			<div className="credit-header">
				{showBanner && (
					<div style={!error ? successBannerStyle : errorBannerStyle}>
						<span>{!error ? success : error}</span>
					</div>
				)}

				{/* <div className="flex flex-col py-2 px-4">
					<p className="f14 font-weight-bold">Top-up</p>
					<div className="flex justify-around mb-30">
						{amountList.map((data, index) => (
							<div
								key={index}
								className={`flex justify-center items-center amount-circle ${data.classSelected}`}
								onClick={() => selectAmount(data, index)}
							>
								<div
									className="flex justify-center items-center"
									style={{ width: "40px", height: "40px" }}
								>
									<span className="fs14 mr-1">{data.currency}</span>
									<span className="fs26 font500">{data.amountValue}</span>
								</div>
							</div>
						))}
					</div>
				</div>

				<div className="flex items-center py-2 px-4 mt-10 mb-10">
					<div className="flex flex-col justify-between">
						<div className="flex items-center">
							<span className="me-3" style={{ fontSize: "14px" }}>$</span>
							<input
								id="inputOtherAmount"
								placeholder="0.00"
								type="number"
								value={selectedAmount === 0 ? "" : selectedAmount}
								className="form-control form-control-lg form-input-box-150"
								onChange={modifyAmount}
							/>
						</div>
					</div>
				</div>

				<div className="partition-hr" /> */}

				{!codeApplied && (
					<div className="flex items-center py-2 px-4 mt-2">
						<span className="f14 font-weight-bold text-size-13 whitespace-nowrap">Partner code</span>
						<div className="flex items-center px-3 mt-1 relative">
							<span className="me-2">
								<img
									style={{ width: "20px", cursor: "pointer", zIndex: 1001 }}
									src="/img/infoIcon.png"
									alt="info"
									onMouseEnter={handleMouseEnter}
									onMouseLeave={handleMouseLeave}
								/>
							</span>
							{isTooltipVisible && (
								<div
									className="balance-tooltip absolute w-40 bg-slate-700 text-white p-2 rounded-md text-size-12 top-[-90px] left-[-50px]"
									style={{ zIndex: 1002 }}
								>
									Enter your partner code here. If you added the code already
									you don't need to enter it again
								</div>
							)}
							<input
								id="inputPromoCode"
								placeholder="Enter code here"
								type="text"
								disabled={disabledPromoCode}
								className="form-control form-control-lg form-input-box-150 mr-2"
								onChange={changePromoCode}
							/>

							<button
								className="btn btn-block btn-lg btn-icon"
								style={
									disabledApplyBtn
										? {
											width: "",
											borderRadius: "10px",
											backgroundColor: "#fff",
											border: "1px solid #638dff",
											color: "#638dff",
										}
										: {
											width: "",
											borderRadius: "10px",
											color: "#fff",
											...BUTTON_BACKGROUND_COLOR_STYLE,
										}
								}
								disabled={disabledApplyBtn}
								onClick={applyPromoCode}
							>
								{
									applyLoading ? 
									<Spinner
										name="circle"
										color="#ffffff"
										fadeIn="none"
									/>
										:
										"Apply"
								}
							</button>
						</div>
					</div>
				)}

				{/* <div className="form-group code-form-group mb-0 py-2 px-4">
					<button
						onClick={handleSubmitAmount}
						className="btn btn-block btn-lg btn-icon code-btn-100-per"
						disabled={!selectedAmount}
						style={BUTTON_BACKGROUND_COLOR_STYLE}
					>
						Update Payment Details
					</button>
				</div>

				<span style={{ fontSize: "10px", padding: "0 0 0 30px" }}>
					Note that payments are in US Dollars
				</span> */}
			</div>
		</div>
	);
};

export default GetCreditModal;
